










import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class AgreementCheck extends Vue {
  // 是否已勾选（父组件可同步校验状态用）
  @Prop({ default: false })
  value!: boolean;

  // 是否处于「校验中」高亮状态（未勾选被点提交时置 true，勾选后清除）
  @Prop({ default: false })
  isChecking!: boolean;

  isChecked = false;

  @Watch('value', { immediate: true })
  onValueChange(val: boolean) {
    this.isChecked = val;
  }

  onToggle() {
    this.isChecked = !this.isChecked;
    this.$emit('input', this.isChecked);
    this.$emit('change', this.isChecked);
  }

  onLinkClick() {
    this.$emit('link-click');
  }
}
